import React, { useState } from 'react'; // Import useState
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemButton, // Keep ListItemButton
  Tooltip // Import Tooltip
} from '@mui/material';

// Dummy data for algorithms
const dummyAlgorithms = [
  { id: 'algo1', name: 'Round Robin', description: 'Distributes cases evenly among available agents.' },
  { id: 'algo2', name: 'Least Utilized', description: 'Assigns cases to the agent with the fewest current assignments.' },
  { id: 'algo3', name: 'Skill-Based', description: 'Matches cases to agents based on required skills (e.g., language).' },
];

const AutoAssignAlgorithms = () => {
  const [selectedAlgorithm, setSelectedAlgorithm] = useState(null); // Add state for selection

  return (
    <Box mt={2}>
      <Typography variant="h6" gutterBottom>
        Auto-Assign Algorithms
      </Typography>
      {/* Replace Paper/List with horizontally scrollable Box/List */}
      <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', pb: 1 }}>
        <List sx={{ display: 'flex', p: 0 }}> {/* Use flex display */}
          {dummyAlgorithms.map((algo) => (
            <ListItem
              key={algo.id}
              disablePadding // Remove default padding
              sx={{
                display: 'inline-block', // Allow items to sit side-by-side
                width: 'auto', // Adjust width based on content
                mr: 1, // Add margin between items
                border: 1,
                borderColor: 'divider',
                borderRadius: 1,
                bgcolor: selectedAlgorithm === algo.id ? 'action.selected' : 'background.paper', // Highlight selected
              }}
            >
              {/* Wrap ListItemButton with Tooltip */}
              <Tooltip title={algo.description} placement="bottom" arrow>
                <ListItemButton // Make item clickable
                  onClick={() => setSelectedAlgorithm(algo.id)}
                  // Adjust padding and alignment as needed now that secondary text is removed
                  sx={{ textAlign: 'center', p: 1.5 }}
                >
                  <ListItemText
                    primary={algo.name}
                    // Remove secondary text, it's now in the tooltip
                    primaryTypographyProps={{ fontWeight: 'medium', whiteSpace: 'nowrap' }} // Ensure name doesn't wrap
                  />
                </ListItemButton>
              </Tooltip>
            </ListItem>
          ))}
        </List>
      </Box>
      {/* Remove the placeholder text */}
      {/*
      <Typography variant="caption" color="text.secondary" mt={1} display="block">
        Note: Algorithm selection and execution is not yet implemented.
      </Typography>
      */}
    </Box>
  );
};

export default AutoAssignAlgorithms;
